<template>
  <el-dialog
    :title="$t('userGroupManagement.accountList')"
    :visible.sync="dialogInnerVisible"
    width="600px"
    :before-close="handleClose"
    :append-to-body="true"
    style="z-index: 2014"
  >
    <el-table
      :data="innerTableData"
      :row-class-name="tableAddClass"
      border
    >
      <el-table-column type="index" :label="$t('table.countText')" width="60" align="center" />
      <el-table-column :label="$t('RoleManagement.child.role')" align="center" prop="loginName" />
<!--      <el-table-column :label="$t('RoleManagement.child.rolename')" align="center" prop="realName" />-->
      <el-table-column :label="$t('userGroupManagement.country')" align="center" prop="organizationName">
        <template slot-scope="scope">
          {{ scope.row.organizationName.includes('UK') ? 'UK' : 'AU' }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.operationText')" align="center" width="145">
        <template v-slot="{ row, $index }">
          <el-button v-if="row.userId === $store.getters.userInfo.id" type="text" disabled>{{ $t('currentUserText') }}</el-button>
          <el-button v-else type="text" @click="handleCurrentChange(row, $index)">{{ $t('changeText') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import {commonApi} from '@/api';
import {setToken} from '@/utils/auth';
export default {
  name: 'UserDialog',
  data() {
    return {
      dialogInnerVisible: false,
      innerTableData: [],
      currentRow: {}
    };
  },
  mounted() {
    this.$store.dispatch('user/getUserGroupList').then((res) => {
      this.$emit('isShowSwitch', !!res?.length);
    });
    this.$store.dispatch('dashboard/getUkTenant');
  },
  methods: {
    async show() {
      const userGroup = this.$store.getters.userGroup;
      if (!userGroup.length) {
        this.$store.dispatch('user/getUserGroupList').then((res) => {
          this.dialogInnerVisible = true;
          this.innerTableData = res;
        });
      } else {
        this.dialogInnerVisible = true;
        this.innerTableData = userGroup;
      }
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      commonApi['getUserToken']({userId: val.userId}).then(res => {
        const ACCESS_TOKEN = res.access_token;
        if (ACCESS_TOKEN) {
          this.$store.dispatch('user/setToken', ACCESS_TOKEN);
          setToken(ACCESS_TOKEN); // 有的话存储token
          location.href = location.href.replace(location.hash, '');
          this.closeAllTags();
        }
      });
    },
    closeAllTags() {
      this.$store.dispatch('tagsView/delAllViews').then(() => {
        this.$router.push('/');
      });
    },
    tableAddClass({row}) {
      if (row.userId === this.$store.getters.userInfo.id) {
        return 'cur-user-row';
      }
      return '';
    },
    handleClose() {
      this.dialogInnerVisible = false;
    }
  }
};
</script>

<style scoped>
/deep/.el-table .cur-user-row {
  background-color: rgb(255, 241, 231);
}
</style>
